import { createContext } from "react";
import { emptyPartners, IPartner } from "../../../../types/partners.type";

type InitialStateType = {
  partner: IPartner
  savePartner: (Data: IPartner) => Promise<{
    ok: boolean;
    data: IPartner;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};


export const initialState: InitialStateType = {
  partner: emptyPartners(),
  savePartner: () => Promise.reject({
    ok: false,
    data: emptyPartners(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}
export const PartnerDashboardContext = createContext(initialState)